// Teachers.js
import { useEffect, useState } from "react";
import {
  getSubjects,
  addTeacher,
  getTeachers,
  deleteTeacher,
  updateTeacher,
} from "../services/firebaseService";

export default function Teachers() {
  const [teacherName, setTeacherName] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [selectedSubjects, setSelectedSubjects] = useState([]);
  const [status, setStatus] = useState("Active");
  const [teachers, setTeachers] = useState([]);
  const [editingId, setEditingId] = useState(null);
  const [isEditing, setIsEditing] = useState(false);

  useEffect(() => {
    getSubjects(setSubjects);
    getTeachers(setTeachers);
  }, []);

  const toggleSubject = (subjectName) => {
    if (selectedSubjects.includes(subjectName)) {
      setSelectedSubjects(
        selectedSubjects.filter((item) => item !== subjectName)
      );
    } else {
      setSelectedSubjects([...selectedSubjects, subjectName]);
    }
  };

  const handleSave = async () => {
    if (!teacherName.trim()) {
      alert("Please Enter Teacher Name");
      return;
    }

    if (selectedSubjects.length === 0) {
      alert("Please Select At Least One Subject");
      return;
    }

    const teacher = {
      name: teacherName.trim(),
      subjects: selectedSubjects,
      status,
      createdAt: Date.now(),
    };

    try {
      if (isEditing && editingId) {
        // Update existing teacher
        await updateTeacher(editingId, {
          name: teacherName.trim(),
          subjects: selectedSubjects,
          status,
        });
        setIsEditing(false);
        setEditingId(null);
      } else {
        // Add new teacher
        await addTeacher(teacher);
      }

      setTeacherName("");
      setSelectedSubjects([]);
      setStatus("Active");
    } catch (error) {
      console.error(error);
      alert("Failed to save teacher.");
    }
  };

  const handleDelete = async (id) => {
    if (!window.confirm("Delete Teacher?")) return;

    try {
      await deleteTeacher(id);
    } catch (error) {
      console.error(error);
      alert("Failed to delete teacher.");
    }
  };

  const handleEdit = (teacher) => {
    setTeacherName(teacher.name);
    setSelectedSubjects(teacher.subjects || []);
    setStatus(teacher.status || "Active");
    setEditingId(teacher.id);
    setIsEditing(true);
    // Scroll to form
    document.querySelector(".form-container")?.scrollIntoView({ behavior: "smooth" });
  };

  const handleCancel = () => {
    setTeacherName("");
    setSelectedSubjects([]);
    setStatus("Active");
    setEditingId(null);
    setIsEditing(false);
  };

  return (
    <div
      style={{
        maxWidth: "700px",
        margin: "20px auto",
        padding: "15px",
      }}
    >
      <h2>Teacher Management</h2>

      <div
        className="form-container"
        style={{
          background: "#fff",
          padding: "20px",
          borderRadius: "10px",
          boxShadow: "0 2px 10px rgba(0,0,0,.08)",
        }}
      >
        <div style={{ marginBottom: 20 }}>
          <label>Teacher Name *</label>

          <input
            type="text"
            placeholder="Enter Teacher Name"
            value={teacherName}
            onChange={(e) => setTeacherName(e.target.value)}
            style={{
              width: "100%",
              padding: "12px",
              marginTop: 6,
              borderRadius: 8,
              border: "1px solid #ccc",
              boxSizing: "border-box",
            }}
          />
        </div>

        <div style={{ marginBottom: 20 }}>
          <label>Select Subjects *</label>

          <div
            style={{
              marginTop: 10,
              display: "flex",
              flexWrap: "wrap",
              gap: 10,
            }}
          >
            {subjects.length === 0 ? (
              <p>No Subjects Added</p>
            ) : (
              subjects.map((subject) => (
                <label
                  key={subject.id}
                  style={{
                    border: "1px solid #ddd",
                    borderRadius: 8,
                    padding: "8px 12px",
                    cursor: "pointer",
                    background: selectedSubjects.includes(subject.name)
                      ? "#2563eb"
                      : "#fff",
                    color: selectedSubjects.includes(subject.name)
                      ? "#fff"
                      : "#000",
                  }}
                >
                  <input
                    type="checkbox"
                    checked={selectedSubjects.includes(subject.name)}
                    onChange={() => toggleSubject(subject.name)}
                    style={{ marginRight: 8 }}
                  />

                  {subject.name}
                </label>
              ))
            )}
          </div>
        </div>

        <div style={{ marginBottom: 20 }}>
          <label>Status</label>

          <select
            value={status}
            onChange={(e) => setStatus(e.target.value)}
            style={{
              width: "100%",
              padding: 12,
              marginTop: 6,
              borderRadius: 8,
            }}
          >
            <option value="Active">Active</option>
            <option value="Inactive">Inactive</option>
          </select>
        </div>

        <div style={{ display: "flex", gap: "10px" }}>
          <button
            onClick={handleSave}
            style={{
              flex: 1,
              padding: "14px",
              background: isEditing ? "#f59e0b" : "#2563eb",
              color: "#fff",
              border: "none",
              borderRadius: 8,
              cursor: "pointer",
              fontWeight: "bold",
              fontSize: 16,
            }}
          >
            {isEditing ? "✏️ Update Teacher" : "💾 Save Teacher"}
          </button>

          {isEditing && (
            <button
              onClick={handleCancel}
              style={{
                padding: "14px 24px",
                background: "#6b7280",
                color: "#fff",
                border: "none",
                borderRadius: 8,
                cursor: "pointer",
                fontWeight: "bold",
                fontSize: 16,
              }}
            >
              Cancel
            </button>
          )}
        </div>

        {isEditing && (
          <p style={{ marginTop: 12, color: "#f59e0b", fontSize: "0.9rem" }}>
            ✏️ Editing: {teacherName}
          </p>
        )}
      </div>

      <div
        style={{
          marginTop: 25,
          background: "#fff",
          padding: 20,
          borderRadius: 10,
          boxShadow: "0 2px 10px rgba(0,0,0,.08)",
        }}
      >
        <h3>Teachers ({teachers.length})</h3>

        {teachers.length === 0 ? (
          <p>No Teachers Added.</p>
        ) : (
          teachers.map((teacher) => (
            <div
              key={teacher.id}
              style={{
                border: "1px solid #ddd",
                borderRadius: 10,
                padding: 15,
                marginTop: 15,
              }}
            >
              <h3 style={{ margin: "0 0 8px 0" }}>{teacher.name}</h3>

              <p style={{ margin: "4px 0" }}>
                <strong>Subjects:</strong>{" "}
                {Array.isArray(teacher.subjects) && teacher.subjects.length > 0
                  ? teacher.subjects.join(", ")
                  : "No subjects assigned"}
              </p>

              <p style={{ margin: "4px 0 12px 0" }}>
                <strong>Status:</strong>{" "}
                <span
                  style={{
                    color: teacher.status === "Active" ? "#16a34a" : "#dc2626",
                    fontWeight: "500",
                  }}
                >
                  {teacher.status}
                </span>
              </p>

              <div
                style={{
                  display: "flex",
                  gap: "10px",
                  flexWrap: "wrap",
                }}
              >
                <button
                  onClick={() => handleEdit(teacher)}
                  style={{
                    background: "#f59e0b",
                    color: "#fff",
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: 6,
                    cursor: "pointer",
                    fontWeight: "500",
                    flex: "1",
                    minWidth: "80px",
                  }}
                >
                  ✏️ Edit
                </button>

                <button
                  onClick={() => handleDelete(teacher.id)}
                  style={{
                    background: "#dc2626",
                    color: "#fff",
                    border: "none",
                    padding: "10px 20px",
                    borderRadius: 6,
                    cursor: "pointer",
                    fontWeight: "500",
                    flex: "1",
                    minWidth: "80px",
                  }}
                >
                  🗑 Delete
                </button>
              </div>
            </div>
          ))
        )}
      </div>
    </div>
  );
}